var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 120 120",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "fire") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.41 11.41)",
    stroke: "#6B6B6B",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 48.277,
    cy: 48.277,
    r: 48.277
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.3293 69.907s-5.0158-26.333 25.706-38.559c19.75-7.8372 16.615-14.42 16.615-14.42s15.988 18.809-4.3888 38.559c-13.218 12.937 12.167 34.453 17.529 38.742",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41.38 60.503s14.107 5.6428 21.631-8.7776c7.2102-14.42 2.5079-17.555 2.5079-17.555s27.9 5.6428 21.631 42.948",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire);
export default __webpack_public_path__ + "static/media/fire.d9aa7920aecbe9af36f12498e461f10e.svg";
export { ForwardRef as ReactComponent };